<!-- PSYCHOLOGIST SPECIALTIES: UMORE ANSIA STRESS AUTOSTIMA AFFETTIVITA_E_RELAZIONI
DIPENDENZE LAVORO CRESCITA PERSONALE RAGGIUNGIMENTO OBBIETTIVI -->

<div class="toastContainer"></div>
<div class="bigger-container">
  <div class="left-section">
    <p class="filter-title">Filtra</p>
    <form class="filters" [formGroup]="form">
      <div>
        <label for="status">Cerca per ID</label>
        <input
          id="filters-doc_ref"
          type="text"
          formControlName="doc_ref"
          placeholder="Cerca per ID"
        />
      </div>
      <div>
        <label for="status">Cerca per nome e cognome</label>
        <input
          id="filters-name"
          type="text"
          formControlName="name"
          placeholder="Cerca per nome/cognome"
        />
      </div>
      <div>
        <label for="status">Cerca per email</label>
        <input
          id="filters-email"
          type="text"
          formControlName="email"
          placeholder="Cerca per email"
        />
      </div>
      <hr
        class="w-100 my-3 text-white border-2 rounded border-light opacity-100"
      />
      <div class="elements-limit-container w-100">
        <label for="specialty" class="w-100">Specializzazioni:</label>
        <div class="d-flex justify-content-start text-xs">
          <!-- * UMORE -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="umore" formControlName="umore" />
            <label class="pointer" for="umore">Umore</label>
          </div>
          <!-- * ANSIA -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="ansia" formControlName="ansia" />
            <label class="pointer" for="ansia">Ansia</label>
          </div>
          <!-- * STRESS -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="stress" formControlName="stress" />
            <label class="pointer" for="stress">Stress</label>
          </div>
          <!-- * AUTOSTIMA -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="autostima" formControlName="autostima" />
            <label class="pointer" for="autostima">Autostima</label>
          </div>
          <!-- * AFFETTIVITA_E_RELAZIONI -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="affettivita_e_relazioni"
              formControlName="affettivita_e_relazioni"
            />
            <label class="pointer" for="affettivita_e_relazioni"
              >Affettività e relazioni</label
            >
          </div>
          <!-- * DIPENDENZE -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="dipendenze"
              formControlName="dipendenze"
            />
            <label class="pointer" for="dipendenze">Dipendenze</label>
          </div>
          <!-- * LAVORO -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="lavoro" formControlName="lavoro" />
            <label class="pointer" for="lavoro">Lavoro</label>
          </div>
          <!-- * CRESCITA_PERSONALE -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="crescita_personale"
              formControlName="crescita_personale"
            />
            <label class="pointer" for="crescita_personale"
              >Crescita personale</label
            >
          </div>
          <!-- * RAGGIUNGIMENTO_OBIETTIVI -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="raggiungimento_obiettivi"
              formControlName="raggiungimento_obiettivi"
            />
            <label class="pointer" for="raggiungimento_obiettivi"
              >Raggiungimento obiettivi</label
            >
          </div>

          <!-- FOBIE -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="fobie" formControlName="fobie" />
            <label class="pointer" for="fobie">Fobie</label>
          </div>
          <!-- ALIMENTAZIONE -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="alimentazione"
              formControlName="alimentazione"
            />
            <label class="pointer" for="alimentazione">Alimentazione</label>
          </div>
          <!-- SESSUALITÀ -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="sessualità"
              formControlName="sessualità"
            />
            <label class="pointer" for="sessualità">Sessualità</label>
          </div>
          <!-- GENITORIALITÀ -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input
              type="checkbox"
              id="genitorialità"
              formControlName="genitorialità"
            />
            <label class="pointer" for="genitorialità">Genitorialità</label>
          </div>
          <!-- LUTTI -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="lutti" formControlName="lutti" />
            <label class="pointer" for="lutti">Lutti</label>
          </div>
          <!-- TRAUMI -->
          <div
            class="d-flex justify-content-start flex-row align-items-center gap-1"
          >
            <input type="checkbox" id="traumi" formControlName="traumi" />
            <label class="pointer" for="traumi">Traumi</label>
          </div>
        </div>
      </div>
      <button
        class="reset-button"
        data-cy="reset-button"
        (click)="resetFilters()"
      >
        RESET
      </button>
    </form>
  </div>
  <div class="right-section">
    <div class="smaller-container">
      <p class="smaller-text">Psicologi Family Happy</p>
      <div class="smaller-bar"></div>
    </div>
    <div style="max-height: 70vh; overflow-y: auto">
      <table>
        <th>Nome</th>
        <th>Cognome</th>
        <th>Email</th>
        <th>Cellulare</th>
        <!-- <th>Elimina</th> -->
        <a
          *ngFor="let b of psychologists"
          (click)="$event.stopPropagation(); rowClick(b)"
          [routerLink]="['/psychologist-detail', b.doc_ref]"
          [href]="'/colf-detail' + b.doc_ref"
          class="link-no-style"
          style="display: table-row"
        >
          <td class="text-center">{{ b.name }}</td>
          <td class="text-center">{{ b.surname }}</td>
          <td class="text-center">{{ b.email }}</td>

          <td class="text-center">
            {{ b.phone
            }}<i
              class="ms-2 bi bi-clipboard"
              (click)="
                $event.stopImmediatePropagation();
                $event.preventDefault();
                copyToClipboard(b.phone)
              "
            ></i>
          </td>
        </a>
        <tr *ngIf="psychologists.length === 0">
          <td colspan="7" style="text-align: center">
            Non sono stati trovati psicologi che soddisfano i criteri di
            ricerca.
          </td>
        </tr>
      </table>
    </div>

    <div class="table-footer">
      <div></div>
      <div class="elements-limit-container">
        <label for="elements-number">Righe per pagina</label>
        <select id="elements-number" [formControl]="elementsPerPage">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
      </div>
    </div>
  </div>
</div>

<!--Alert section-->
<app-alert
  *ngIf="showAlert"
  (save)="onAlertConfimation($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione!'"
  [message]="'Vuoi davvero eliminare questo profilo psicologo?'"
>
</app-alert>
